import React from "react";
import { View, ScrollView, KeyboardAvoidingView } from "react-native";

import { isAndroid, navigate, openURL, isWeb } from "../../../helpers/utils";

import cardStyles from "../home/gated-product/styles";
import ManaButton from "../common/ManaButton";
import ManaTextInput from "../common/ManaTextInput";
import AppMessages from "../../../config/AppMessages";
import appStyles from "../../appStyles";
import appPages from "../../../appPages";

import Header from "../common/header/index";

import IntegrationsHelper from "./IntegrationsHelper";
import IntegrationsFabButton from "./IntegrationsFabButton";

import IntegrationsHealth from "./home/IntegrationsHealth";
import IntegrationsList from "./home/IntegrationsList";
import IntegrationsScore from "./home/IntegrationsScore";
import INTEGRATIONS from "./home/data";
import SnoozeIntegrationDialog from "./common/SnoozeIntegrationDialog";
import IntegrationIcons from "../common/icons/integrations/index";

export default class IntegrationsPageV2 extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    this.state = {
      currentUser: this.controller.state?.currentUser,
      activeIntegrations: [],
      availableIntegrations: [],
    };
  }

  componentDidMount = async () => {
    if (this.controller.hasNavigation()) {
      this.focusListenerUnsub = this.props.navigation.addListener(
        "focus",
        () => {
          this.iniIntegrations();
        },
      );
    } else {
      this.iniIntegrations();
    }
  };

  componentWillUnmount = async () => {
    if (this.focusListenerUnsub) this.focusListenerUnsub();
  };

  iniIntegrations = () => {
    //const { integrations, autotrack_options } = this.controller.state ?.settings || { integrations: {}, autotrack_options: {} };
    const { devices } = this.controller.state?.settings || { devices: {} };
    const { integrations_score } = this.controller.state?.stats || {
      integrations_score: 0,
    };

    // Active integrations
    let activeIntegrations = [];
    let availableIntegrations = [];
    let hasActiveCalendar = false;

    // Hide slack for non-admins
    const { show_admin_tools: isAdmin } = this.controller.state?.settings || {};
    let filteredIntegrations = isAdmin
      ? INTEGRATIONS
      : INTEGRATIONS.filter((int) => int.value != "slack");

    console.log(filteredIntegrations);

    filteredIntegrations.forEach((i) => {
      if (!i.isDisabled) {
        // Autotrack vs suggest
        //i.hasAutoTrack = autotrack_options[i.autotrack_value];
        //const isEnabled = !!integrations[i.value];

        let isEnabled = false;
        let isAutoTrack = false;
        let isConnected = false;
        const intDevices = devices[i.id];
        (intDevices || []).forEach((d) => {
          if (d.isEnabled) isEnabled = true;
          if (d.isAutoTrack) isAutoTrack = true;
          if (d.isConnected) isConnected = true;
          if (!isConnected && (i.id === "slack" || i.id === "chrome")) {
            isConnected = d.isEnabled; //hack to show chrome and slack as connected even if we have no data from them
          }
        });

        i.hasAutoTrack = isAutoTrack;

        // Active vs available
        if (isConnected) {
          if (i.isCalendar) hasActiveCalendar = true;
          activeIntegrations.push(i);
        } else {
          availableIntegrations.push(i);
        }
      }
    });

    // Once a user has connected one calendar, move the second calendar to last position of "add integrations"
    if (hasActiveCalendar) {
      availableIntegrations = availableIntegrations.sort((a, b) => {
        return (a.isCalendar || 1) > (b.isCalendar || 0) ? 1 : -1;
      });
    }

    this.setState((state) => ({
      ...state,
      activeIntegrations,
      availableIntegrations,
      integrationsScore: integrations_score,
    }));
  };

  updateNotes = (note) => {
    this.setState((state) => ({ ...state, note }));
  };

  sendUserEmail = () => {
    const { note, currentUser } = this.state;

    const emailUrl = `${AppMessages.SupportEmail}?subject=Integrations&body=${note}%0ASent from account ${currentUser}`;
    openURL(emailUrl);
  };

  // ------------------------------------- ALL -------------------------------------
  toggleAll = (isEnabled) => {
    if (isEnabled) {
      this.saveAllIntegrations({}, true);
    } else {
      this.setState((state) => ({
        ...state,
        snoozeAccount: { id: "all" },
      }));
    }
  };

  saveAllIntegrations = (data, isEnabled = false) => {
    const { activeIntegrations } = this.state;

    let postData = {};
    if (data.snooze) postData.snooze = data.snooze;
    if (data.snooze_date) postData.snooze_date = data.snooze_date;

    activeIntegrations.forEach((int) => {
      postData[int.value] = isEnabled;
      postData["id"] = "all";
      postData["isEnabled"] = isEnabled;
    });
    IntegrationsHelper.saveIntegrationSource(this.controller, postData, () => {
      this.controller.getItems(appPages.integrationsV2);
    });
  };

  onCancel = () => {
    this.setState((state) => ({ ...state, snoozeAccount: null }));
  };

  viewRules = () => {
    navigate(this.controller, appPages.integrationRulesPage);
  };

  viewHistory = () => {
    navigate(this.controller, appPages.integrationsHistoryPage);
  };

  goBack = () => {
    this.controller.navigate("feed");
  };

  // ------------------------------------- RENDER -------------------------------------
  render() {
    const {
      note,
      isLoading,
      mariMessage,
      activeIntegrations,
      availableIntegrations,
      integrationsScore,
      snoozeAccount,
    } = this.state;

    return (
      <View style={[appStyles.container, { backgroundColor: "#FFF" }]}>
        <Header
          controller={this.controller}
          goBack={this.goBack}
          title="Integrations"
          subTitle="See suggestions or autotrack time from other apps"
          isLoading={isLoading}
          iconTag={<IntegrationIcons.RulesIcon onPress={this.viewRules} />}
          iconTag2={<IntegrationIcons.HistoryIcon onPress={this.viewHistory} />}
        />

        <KeyboardAvoidingView
          style={appStyles.kbViewNoFooter}
          behavior="position"
          keyboardVerticalOffset={isAndroid ? 30 : 0}
        >
          <ScrollView
            contentContainerStyle={appStyles.scrollViewContent}
            style={appStyles.scrollView}
          >
            {/* Score */}
            <IntegrationsScore hours={integrationsScore} />

            {/* Health */}
            <IntegrationsHealth count={activeIntegrations.length} />

            {/* Available integrations list */}
            <IntegrationsList
              controller={this.controller}
              items={availableIntegrations}
              title="Add Integrations"
              onItemSelected={IntegrationsHelper.toggleIntegration}
            />

            {/* Active integrations list */}
            <IntegrationsList
              controller={this.controller}
              items={activeIntegrations}
              title="Connected Integrations"
              onItemSelected={IntegrationsHelper.toggleIntegration}
              toggleAll={this.toggleAll}
              isActive={true}
            />

            <View style={cardStyles.messageContainer}>
              <ManaTextInput
                name={"integrationNotes"}
                style={[cardStyles.input, { borderRadius: 10, marginTop: 10 }]}
                autoFocus={false}
                multiline={true}
                contentHeight={70}
                value={note}
                onTextChanged={(text) => this.updateNotes(text)}
                placeholderTextColor="#9C9EB9"
                placeholder={AppMessages.IntegrationsDefaultUserMessage}
                debounceDelay={500}
              />
            </View>

            <View style={[cardStyles.buttons, { marginBottom: 20 }]}>
              <ManaButton
                isMainButton
                disabled={!note}
                onPress={this.sendUserEmail}
                style={{ width: 220 }}
                styleText={cardStyles.buttonText}
                icon={require("../../../assets/integrations/invite.png")}
                text="Send Message"
              />
            </View>
          </ScrollView>
        </KeyboardAvoidingView>

        <IntegrationsFabButton
          mariOptions={{
            mariMessage,
          }}
        />

        <SnoozeIntegrationDialog
          controller={this.controller}
          account={snoozeAccount}
          integrationName={"all"}
          saveIntegrations={this.saveAllIntegrations}
          onCancel={this.onCancel}
        />
      </View>
    );
  }
}
